import React from 'react';
import PropTypes from 'prop-types';
import { renderComponentField } from '@/shared/components/form/FormField';
import './Switch.scss';

export const ToggleButtonField = React.forwardRef(({
  onChange, name, disabled, value,
}, ref) => {
  // Ensure value is boolean and handle undefined/null cases
  const isChecked = Boolean(value);
  
   const handleChange = (e) => {
    onChange(e.target.checked);
  };
  
  return (
    <div style={{ 
      position: 'relative',
      display: 'inline-block',
      verticalAlign: 'middle'
    }}>
      <input
        className="react-switch-checkbox"
        type="checkbox"
        name={name}
        id={name}
        onChange={handleChange}
        checked={isChecked}
        disabled={disabled}
        ref={ref}
        style={{ 
          position: 'absolute',
          opacity: 0,
          pointerEvents: 'auto',
          margin: 0,
          padding: 0,
          border: 'none',
          outline: 'none',
          clip: 'rect(0 0 0 0)',
          WebkitAppearance: 'none',
          MozAppearance: 'none',
          appearance: 'none',
          cursor: 'pointer',
          zIndex: 1
        }}
      />
      <label 
        className='react-switch-label' 
        style={{ 
          background: isChecked ? '#fdb040' : 'rgb(0, 0, 0, 0.2)',
          WebkitUserSelect: 'none',
          MozUserSelect: 'none',
          msUserSelect: 'none',
          userSelect: 'none',
          WebkitTapHighlightColor: 'transparent',
          WebkitTouchCallout: 'none',
          WebkitAppearance: 'none',
          MozAppearance: 'none',
          appearance: 'none',
          border: 'none',
          outline: 'none',
          boxShadow: 'none',
          margin: 0,
          padding: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          cursor: 'pointer',
          width: '45px',
          height: '25px',
          borderRadius: '100px',
          position: 'relative',
          transition: 'all 0.2s ease',
          border: 'none'
        }}
        htmlFor={name}
      >
        <span 
          className="react-switch-button"
          style={{
            content: '',
            position: 'absolute',
            top: '2px',
            left: isChecked ? 'calc(100% - 2px)' : '2px',
            transform: isChecked ? 'translateX(-100%)' : 'translateX(0)',
            width: '20px',
            height: '20px',
            borderRadius: '50%',
            transition: 'all 0.2s ease',
            background: '#fff',
            boxShadow: '0 2px 4px rgba(0,0,0,0.3)',
            WebkitTransform: isChecked ? 'translateX(-100%)' : 'translateX(0)',
            msTransform: isChecked ? 'translateX(-100%)' : 'translateX(0)',
            border: 'none'
          }}
        ></span>
      </label>
    </div>
  );
});

ToggleButtonField.propTypes = {
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  value: PropTypes.any.isRequired, // Avoid warnings, you're coercing it to boolean anyway
};

ToggleButtonField.defaultProps = {
  disabled: false,
};

export default renderComponentField(ToggleButtonField);
